import * as React from 'react';
import { StickyHeader } from 'app/shell/components/sticky-header/sticky-header';
import { CodeMappingsTranslation } from '../constants';
import styles from './code-mappings-header.scss';

interface CodeMappingsHeaderProps {
  translation: CodeMappingsTranslation;
}

export const CodeMappingsHeader: React.FC<CodeMappingsHeaderProps> = ({ translation }) =>
  <StickyHeader
    className={styles.header}>
    <div className={styles.searchSummary}>
      <div className={styles.container}>
        <div className={styles.title}>{translation.mapping_external_values}</div>
      </div>
      <div className="row justify-content-between">
        <div className="col col-auto">
          <h2 className={styles.subTitle}>
            {translation.add_missing_code}
          </h2>
        </div>
      </div>
    </div>
  </StickyHeader>;
